import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { TfiMicrosoftAlt } from "react-icons/tfi";

const SignIn = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((e) => {
      console.log(e);
    });
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-200 px-4">
      <div className="w-full max-w-md bg-white shadow-xl rounded-2xl p-8 flex flex-col items-center gap-2">
        {/* Logo */}
        <img src="/Go.png" alt="Go Logo" className="h-120 object-contain" />

        {/* Title */}
     
       

        {/* Sign-in button */}
        <button
          onClick={handleLogin}
          className=" w-full flex items-center justify-center gap-3 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md shadow transition duration-200"
        >
          <TfiMicrosoftAlt size={20} />
          Sign in
        </button>
      </div>
    </div>
  );
};

export default SignIn;
